var t = require('i18n').t

Ember.Handlebars.registerHelper('if-t', function(value, options) {
    if (t(value) !== '' && !t(value).startsWith('Missing translation:')) {
        return options.fn(this)
    } else {
        return options.inverse(this)
    }
})
